module.exports = __webpack_public_path__ + "static/media/03_07_01.f10aafab.png";